export type NullablePartial<T> = { [P in keyof T]: T[P] | null }

export enum Page {
  REGISTRATION = 'registration',
  MVL = 'manualVehicleLookup',
  VEHICLE_FOUND = 'vehicleFound',
  VEHICLE = 'vehicle',
  LICENCE = 'licence',
  DRIVERS = 'drivers',
  HISTORY = 'history',
  CLAIM_FREE_DISCOUNT = 'claimFreeDiscount',
  PREVIOUS_CANCELLATION = 'previousCancellation',
  PREVIOUS_CANCELLATION_YEAR = 'previousCancellationYear',
  USAGE = 'usage',
  POLICY_START_DATE = 'quote',
  EDIT_DETAILS = 'editDetails',
}

export const PageName: Record<Page, string> = {
  [Page.REGISTRATION]: 'Registration',
  [Page.MVL]: 'Manual Vehicle Lookup',
  [Page.VEHICLE_FOUND]: 'VehicleFound',
  [Page.VEHICLE]: 'Vehicle',
  [Page.LICENCE]: 'Licence',
  [Page.DRIVERS]: 'Drivers',
  [Page.HISTORY]: 'History',
  [Page.CLAIM_FREE_DISCOUNT]: 'Claim Free Discount',
  [Page.PREVIOUS_CANCELLATION]: 'previousCancellation',
  [Page.PREVIOUS_CANCELLATION_YEAR]: 'previousCancellationYear',
  [Page.USAGE]: 'Usage',
  [Page.POLICY_START_DATE]: 'PolicyStartDate',
  [Page.EDIT_DETAILS]: 'Edit Details',
}

export const stepPages = [
  Page.REGISTRATION,
  Page.MVL,
  Page.VEHICLE_FOUND,
  Page.VEHICLE,
  Page.DRIVERS,
  Page.LICENCE,
  Page.HISTORY,
  Page.CLAIM_FREE_DISCOUNT,
  Page.PREVIOUS_CANCELLATION,
  Page.PREVIOUS_CANCELLATION_YEAR,
  Page.USAGE,
  Page.POLICY_START_DATE,
] as const

export type StepPage = (typeof stepPages)[number]
